import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Contacto`

export function buscarTodos(pais) {
  return http.get(`${API_ENDPOINT}/BuscarTodos/${pais}`)
}

export function enviarMensaje(msgObj) {
  return http.post(`${API_ENDPOINT}/EnviarMensaje/`, msgObj)
}
